import { UPDATE_SWAP_TRANSACTION } from 'state/swap/constants'

export function updateSwapTransaction(payload) {
  return {
    type: UPDATE_SWAP_TRANSACTION,
    payload,
  }
}
